var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#C54928"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.356 15.876L35.212 34.62H28.348L27.204 15.876H36.356ZM31.78 38.316C33.0413 38.316 34.112 38.7707 34.992 39.68C35.872 40.56 36.312 41.616 36.312 42.848C36.312 44.08 35.872 45.1507 34.992 46.06C34.112 46.94 33.0413 47.38 31.78 47.38C30.5187 47.38 29.448 46.94 28.568 46.06C27.688 45.1507 27.248 44.08 27.248 42.848C27.248 41.616 27.688 40.56 28.568 39.68C29.448 38.7707 30.5187 38.316 31.78 38.316Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/Alert.3c55d7d6f40b3e7fc5c91c9ce8a14840.svg";
export { ForwardRef as ReactComponent };